module.exports = __webpack_public_path__ + "img/irys.e6cb9518.jpg";